import React, { useEffect } from 'react';
import {
  NotificationRenderer,
  ScreenReaderAlertRenderer,
  ToastRenderer,
  ToastsPosition
} from 'ehs-react';
import { usePortletStore } from './App';

export function MainView(): React.JSX.Element {
  const config = usePortletStore(state => state.configuration);
  useEffect(() => {
    const element = document.getElementById('page-title');
    if (element) {
      element.textContent = config.domainName;
    }
  }, [config.domainName]);

  return (
    <>
      <NotificationRenderer
        className={
          config.uiVariant === 'PATIENT' ? 'patient-portal' : undefined
        }
      />
      <ToastRenderer
        position={ToastsPosition[config.toaststyle.position]}
        className={
          config.uiVariant === 'PATIENT' ? 'patient-portal' : undefined
        }
      />
      <ScreenReaderAlertRenderer />
    </>
  );
}
